import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status--partly",
  "use": "status--partly-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"status--partly\">\n  <g fill=\"none\" fill-rule=\"nonzero\">\n    <path fill=\"#E24B0F\" d=\"M32 20c-6.627 0-12 5.373-12 12s5.373 12 12 12v12C18.745 56 8 45.255 8 32S18.745 8 32 8v12z\" />\n    <path fill=\"#7AC143\" d=\"M32 44c6.627 0 12-5.373 12-12s-5.373-12-12-12V8c13.255 0 24 10.745 24 24S45.255 56 32 56V44z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol